import { render, staticRenderFns } from "./efItem4.vue?vue&type=template&id=188b1195&lang=pug&"
import script from "./efItem4.vue?vue&type=script&lang=js&"
export * from "./efItem4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports